import React from 'react'
import Modal from '../../../components/modal'
import { useAuth } from '../../../contexts/auth'
import { CardIcon, CardList, CardTitle, ListItem, OptionCard } from '../selling-option-card'
import Hammer from '../../../components/svg/hammer'
import { Button } from '../../../components/button'
import { ListingType } from '../../../api-client/enums'
import PurchaseTag from '../../../components/svg/purchase-tag'
import CashOffer from '../../../components/svg/cash-offer'
import { checkPermission } from '../../../utils/permissions'
import { permissions } from '../../../constants'

const SelectListingType = ({ onClose, onSelect }) => {
  const [{ userDetails, isAuthenticated }] = useAuth()

  const getCashOfferPermissions = () => {
    if (!isAuthenticated) return true
    return checkPermission(userDetails.permissions, [permissions.manageCashOffer])
  }

  const handleStartListing = (listingType) => {
    onSelect(listingType)
  }

  return (
    <Modal onClose={onClose}>
      <div
        className='root'
        style={userDetails.verified ? { width: '115.8rem' } : { width: '80rem' }}
      >
        <h2 className='title'>How do you want to sell your vehicle?</h2>

        <div className='options-wrapper'>
          {userDetails.verified && (
            <>
              <OptionCard className='options-card'>
                <CardTitle>Live Auction</CardTitle>
                <CardIcon>
                  <Hammer />
                </CardIcon>
                <Button onClick={() => handleStartListing(ListingType.Auction)}>
                  Auction Vehicle
                </Button>
                <CardList>
                  <ListItem pros className='options-card--list-item'>
                    Pro: Puts multiple people competing to buy your car, always sure to get the most
                    for your vehicle!
                  </ListItem>
                  <ListItem pros className='options-card--list-item'>
                    Pro: Takes away the pressure of knowing how to price your vehicle accurately
                  </ListItem>
                  <ListItem pros={false} className='options-card--list-item'>
                    Con: May take time to sell, depending on how many people are looking for a
                    vehicle like yours
                  </ListItem>
                </CardList>
              </OptionCard>

              <OptionCard className='options-card'>
                <CardTitle>Buy it Now Listing</CardTitle>
                <CardIcon>
                  <PurchaseTag />
                </CardIcon>
                <Button onClick={() => handleStartListing(ListingType.BuyNow)}>List Vehicle</Button>
                <CardList>
                  <ListItem pros className='options-card--list-item'>
                    Pro: Often quickest and easiest sale type, assuming you are priced right
                  </ListItem>
                  <ListItem pros className='options-card--list-item'>
                    Pro: Lasts 14 days ensuring plenty of time for buyers to find your vehicle
                  </ListItem>
                  <ListItem pros={false} className='options-card--list-item'>
                    Con: Offers and counter offers may be seen as "Haggling"
                  </ListItem>
                </CardList>
              </OptionCard>
            </>
          )}

          {getCashOfferPermissions() && (
            <OptionCard className='options-card'>
              <CardTitle>Quick Cash Offer</CardTitle>
              <CardIcon>
                <CashOffer />
              </CardIcon>
              <Button onClick={() => handleStartListing(ListingType.CashOffer)}>Get Offer</Button>
              <CardList>
                <ListItem pros className='options-card--list-item'>
                  Pro: We pay you cash for your vehicle, no need to wait to see if it sells in
                  auction or to Buy it Now
                </ListItem>
                <ListItem pros className='options-card--list-item'>
                  Pro: Offer is guaranteed and not dependent on a third party
                </ListItem>
                <ListItem pros={false} className='options-card--list-item'>
                  Con: You may get less than a private buyer may pay you via Auction or Buy It Now
                </ListItem>
              </CardList>
            </OptionCard>
          )}
        </div>
        <style jsx>{`
          .root {
            max-width: 100vw;
            background: var(--primary-bg-color);
            padding: 3.3rem 4.3rem 4.3rem;

            .title {
              text-align: center;
              font-size: 2.4rem;
              font-weight: bold;
              padding-bottom: 2.7rem;
            }

            .options-wrapper {
              display: flex;
              flex-direction: row;
              justify-content: center;

              :global(.options-card) {
                background: var(--secondary-bg-color);

                &:not(:last-child) {
                  margin: 0 2.5rem 0 0;
                }
              }

              :global(.options-card--list-item) {
                font-size: 1.6rem;
                font-weight: normal;
              }
            }
          }

          @media (max-width: 1024px) {
            .root {
              .options-wrapper {
                flex-direction: column;
                align-items: center;

                :global(.options-card) {
                  &:not(:last-child) {
                    margin: 0 0 1.5rem 0;
                  }
                }

                :global(.options-card--list-item) {
                  font-size: 1.2rem;
                }
              }
            }
          }
        `}</style>
      </div>
    </Modal>
  )
}

export default SelectListingType
